import React from 'react';

const SvgNeutralEvolution = (props) => (
  <svg width={10} height={2} {...props}>
    <path
      fill="#2b3d54"
      fillRule="evenodd"
      stroke="#2b3d54"
      strokeWidth={0.5}
      d="M1.19.76l7.697.072.006.595-7.7-.072z"
    />
  </svg>
);

export default SvgNeutralEvolution;
